import { useEffect, useState } from "react";
import {
  AppBar,
  Button,
  debounce,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useAppSelector } from "../../../../../hooks/store-hooks";
import { useProjetosService } from "../../../../../../use-cases/geo-veles";
import { Transition } from "../../../../../components";

export const FormDuplicateProjeto = () => {
  // State
  const { currentUser } = useAppSelector((state) => state.user);
  const {
    duplicateProjetoForm,
    openDuplicateProjetoForm,
    duplicateProjetoForm: { errors, touched },
  } = useAppSelector((state) => state.projetos);
  // useState
  const [loading, setLoading] = useState<boolean>(true);
  // Hook
  const { 
    setDuplicateProjeto, 
    setOpenDuplicateProjetoForm,
    setDuplicateProjetoFormNome
  } = useProjetosService();
  // Function
  const closeDialog = () => {
    setOpenDuplicateProjetoForm({
      openForm: false,
      idVelesGeoProjeto: 0,
      nome: "",
      idUsuario: 0,
    });
  };
  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      {loading ? (
        <></>
      ) : (
        <Dialog
          TransitionComponent={Transition}
          open={openDuplicateProjetoForm}
          onClose={closeDialog}
          maxWidth={false} // Remove a limitação padrão
          PaperProps={{
            sx: { width: "40vw", height: "40vh" }, // Define tamanho personalizado
          }}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <Typography
                textAlign="center"
                sx={{ ml: 2, flex: 1 }}
                textTransform="uppercase"
                fontWeight="bold"
                variant="h6"
                component="div"
              >
                Duplicar Projeto
              </Typography>
            </Toolbar>
          </AppBar>
          <DialogContent dividers sx={{ m: 2 }}>
            <TextField
              defaultValue={duplicateProjetoForm.fields.nome}
              InputLabelProps={{
                shrink: true,
              }}
              
              onChange={debounce((e) => {
                setDuplicateProjetoFormNome(e.target.value);
              }, 300)}
              error={Boolean(
                touched && errors.find((item) => item.key === "nome")
              )}
              helperText={errors.find((item) => item.key === "nome")?.message}
              name="nome"
              fullWidth
              id="nome"
              label="Nome do Projeto"
            />
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 2 }}
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={6}>
                <Button
                  fullWidth
                  autoFocus
                  variant="outlined"
                  onClick={closeDialog}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  disabled={duplicateProjetoForm.fields.nome.trim().length === 0}
                  onClick={() => {
                    setDuplicateProjeto({
                      idVelesGeoProjeto:
                        duplicateProjetoForm.fields.idVelesGeoProjeto,
                      nome: duplicateProjetoForm.fields.nome,
                      idUsuario: currentUser?.IdUsuario ?? 0,
                    });
                  }}
                >
                  Duplicar
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
